import BlTextfieldAv from './BlTextfieldAv.vue'

BlTextfieldAv.install = function(Vue) {
  Vue.component(BlTextfieldAv.name, BlTextfieldAv)
}

export default BlTextfieldAv
